<div class="card-header">
  <span *ngIf="!addNewPackage">Existing Packages</span>
  <span *ngIf="addNewPackage">Add Package</span>
  <button class="btn btn-sm btn-warning float-right"
    style="margin-top: -4px;font-size: 14px;background-color:  rgb(87,200,231);color: #ffffff;height:38px;"
    (click)="toggleDiv('new')">
    <span *ngIf="this.addNewPackage==false">
      <i class="fa fa-plus-circle" style="margin-top:6px;color:#fff;"></i> New Package</span>
    <span *ngIf="this.addNewPackage==true" (click)="getPackageDetails()">
      <i class="fa fa-arrow-left" style="margin-top:6px;color:#fff;"></i> Back</span>
  </button>
</div>
<!--start : package table-->
<div class="content-body padding-top-20 padding-bottom-20" *ngIf="addNewPackage==false">

  <div class="row">
    <!-- <div class="col-xs-2">Filter by </div> -->
    <div class="col-lg-4 col-xs-12 pull-right" style="margin: 10px 0">
      <table style="width: 100%;">
        <tr>
          <td><span class="pull-right" style="margin: 0px 5px;color: rgb(54, 53, 53);">Filter by</span></td>
          <td>
            <select name="packageFilter" id="packageFilter" [(ngModel)]="packageFilter"
              class="form-select form-select-sm pull-right" (change)='onFilterChange(packageFilter)'>
              <option value="">All</option>
              <option value="GENERAL">General</option>
              <option value="ACCOUNT">Accounts</option>
              <option value="OFFLINE">Offline</option>
              <option value="AI">AI</option>
            </select>
          </td>
        </tr>
      </table>
    </div>
  </div>

  <div class="row">


    <p-table [value]="packageDetailsList" [lazy]="true" (onLazyLoad)="onPageChange($event)"
      [paginator]="packageDetailsList!=null && packageDetailsList.length>0" [rows]="rows" [totalRecords]="totalRecords"
      #dt [first]="paging.currentPage">
      <ng-template pTemplate="header">
        <tr style="height:50px;">
          <th class="package-table-header" style="width:100px;text-align: center;">#
          </th>
          <th class="package-table-header" [pSortableColumn]="'pkgName'">Package Name
            <p-sortIcon [field]="'pkgName'"></p-sortIcon>
          </th>
          <th class="package-table-header" [pSortableColumn]="'price'">Price
            <p-sortIcon [field]="'price'"></p-sortIcon>
          </th>
          <th class="package-table-header" [pSortableColumn]="'validity'">Validity (in days)
            <p-sortIcon [field]="'validity'"></p-sortIcon>
          </th>
          <th class="package-table-header" [pSortableColumn]="'associatedAccounts'">Belongs To
            <p-sortIcon [field]="'associatedAccounts'"></p-sortIcon>
          </th>
          <th class="package-table-header" style="width:150px;text-align: center;" [pSortableColumn]="'status'"> Status
            <p-sortIcon [field]="'status'"></p-sortIcon>
          </th>
        </tr>
        <tr style="font-family:Arial, FontAwesome;text-align: center;">
          <td class="primeng-table-search">
            <!-- <input class="primeng-table-search-field" disabled pInputText type="search"
              (input)="dt.filter($event.target.value, 'pkgName', 'contains')"> -->
          </td>
          <td class="primeng-table-search">
            <input class="primeng-table-search-field search-bar-true" placeholder="&#xf002;  Package name" pInputText
              type="text" (input)="onSearch($event.target.value,'name')">
          </td>
          <td class="primeng-table-search">
            <input class="primeng-table-search-field search-bar-true" placeholder="&#xf002;  Price" pInputText
              type="text" (input)="onSearch($event.target.value,'price')">
          </td>
          <td class="primeng-table-search">
            <input class="primeng-table-search-field search-bar-true" placeholder="&#xf002;  Validity" pInputText
              type="text" (input)="onSearch($event.target.value,'validity')">
          </td>
          <td class="primeng-table-search">
            <!-- <input class="primeng-table-search-field" disabled pInputText type="search"
              (input)="dt.filter($event.target.value, 'pkgName', 'contains')"> -->
            <input class="primeng-table-search-field search-bar-true" placeholder="&#xf002;  Account Name" pInputText
              type="text" (input)="onSearch($event.target.value,'accountName')">
          </td>
          <td class="primeng-table-search">
            <!-- <input class="primeng-table-search-field" disabled pInputText type="search"
              (input)="dt.filter($event.target.value, 'pkgName', 'contains')"> -->
          </td>
        </tr>
        <tr *ngIf="packageDetailsList==null || packageDetailsList.length==0"
          style="border-left: 1px solid #f4f4f4;border-right: 1px solid #f4f4f4;border-bottom: 1px solid #f4f4f4;">
          <td colspan="6">
            <div style="padding: 5px;text-align: center;">
              No record found
            </div>
          </td>
        </tr>

      </ng-template>
      <ng-template pTemplate="body" let-itrPackage let-i="rowIndex">
        <tr class="table-striped table-hover" style="cursor: pointer;">
          <td style="text-align: center;" (click)="editPackageDetails(itrPackage);toggleDiv('edit')">{{ i + 1 }}</td>
          <td (click)="editPackageDetails(itrPackage);toggleDiv('edit')">{{itrPackage.pkgName}}</td>
          <td (click)="editPackageDetails(itrPackage);toggleDiv('edit')">{{itrPackage.price}}</td>
          <td (click)="editPackageDetails(itrPackage);toggleDiv('edit')">{{itrPackage.validity}}</td>
          <td (click)="editPackageDetails(itrPackage);toggleDiv('edit')"
            *ngIf='itrPackage.isSpecific==true && (itrPackage.isOffline==false || itrPackage.isOffline == null)'>
            {{itrPackage.associatedAccounts}}</td>
          <td (click)="editPackageDetails(itrPackage);toggleDiv('edit')"
            *ngIf='itrPackage.isSpecific==false && (itrPackage.isOffline==false || itrPackage.isOffline == null)'>
            Universal/AI</td>
          <td (click)="editPackageDetails(itrPackage);toggleDiv('edit')"
            *ngIf='itrPackage.isSpecific==false && itrPackage.isOffline==true'>
            Offline Package</td>
          <td (click)="editPackageDetails(itrPackage);toggleDiv('edit')"
            *ngIf='itrPackage.isSpecific==true && itrPackage.isOffline==true'>
            Offline Package</td>
          <td style="text-align: center;"
            [ngClass]="{'active-row': itrPackage.status, 'inactive-row': !itrPackage.status}">
            <p-inputSwitch [(ngModel)]="itrPackage.status"
              (ngModelChange)="changePackageStatus(itrPackage)"></p-inputSwitch>
          </td>
        </tr>
      </ng-template>

    </p-table>

    <!-- <div *ngIf="packageDetailsList==null || packageDetailsList.length == 0">
      <div>No Records Found</div>
    </div> -->
  </div>
</div>
<!--end : package table-->
<div class="content-body padding-top-20 padding-bottom-20" *ngIf="addNewPackage==true">
  <div class="row">
    <div class="col-lg-6 form-group">
      <label class="form-label">Package Name <span class="mandatory-symbol">*</span></label>
      <span class="desc">Package Name</span>
      <input type="text" [(ngModel)]="packageDetails.pkgName" placeholder="Enter package name here..."
        onkeypress="return /[0-9a-zA-Z-& ]/i.test(event.key)" class="form-control" required>
    </div>
    <div class="col-lg-6 form-group">
      <label class="form-label">Validity <span class="mandatory-symbol">*</span></label>
      <span class="desc">Validity for this package (in days)</span>
      <input type="number" min=1 (keypress)="onlyNumberKey($event)" (paste)="onPasteDaysNumber($event)"
        [(ngModel)]="packageDetails.validity" placeholder="Enter validity (in days) here..." class="form-control"
        required>
    </div>
    <div class="col-lg-12 form-group chiller_cb" style="margin-bottom: 20px !important;">
      <div class="col-lg-6 padding-left-0">
        <input name="isSpecific" id="isSpecific" [(ngModel)]="packageDetails.isSpecific" type="checkbox" />
        <label class="form-label" for="isSpecific">
          Is specific to any account?
          <span *ngIf="packageDetails.isSpecific" class="mandatory-symbol" style="display: contents;">
            *
            <span *ngIf="!selectedAccounts || selectedAccounts.length === 0" style="display: contents;">
              (select at least one account)
            </span>
          </span>
        </label>
        <span></span>
      </div>
      <div class="col-lg-6 padding-left-15">
        <input name="isOffline" id="isOffline" [(ngModel)]="packageDetails.isOffline" type="checkbox" />
        <label class="form-label" for="isOffline">Is Offline Payment?</label>
        <span style="margin-left: 15px;"></span>
      </div>
    </div>
    <div *ngIf="packageDetails.isSpecific" class="col-lg-6 form-group" style="margin-top: -10px;">
      <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="accounts" (onSelect)="onItemSelect($event)"
        (onDeSelect)="OnItemDeSelect($event)" (onSelectAll)="onSelectAll($event)"
        (onDeSelectAll)="onDeSelectAll($event)" placeholder="Select accounts" [(ngModel)]="selectedAccounts">
      </ng-multiselect-dropdown>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-6 form-group" *ngIf="showFundusModule==true">
      <label class="form-label">Fundus Unit(s)</label>
      <span class="desc" *ngIf="fundusUnitPrice==null">Number of units for fundus </span>
      <span class="desc" *ngIf="fundusUnitPrice!=null">Fundus Price = ( Number of fundus units x <i
          class="fa fa-inr"></i>&nbsp;{{ fundusUnitPrice}} )</span>
      <input type="number" min="0" (keypress)="onlyNumberKey($event)" [(ngModel)]="packageDetails.fundusUnit"
        (keyup)="calculatePrice()" placeholder="Enter number of units for fundus here..." class="form-control">
    </div>
    <div class="col-lg-6 form-group" *ngIf="showRefractionModule==true">
      <label class="form-label">Refraction Unit(s)</label>
      <span class="desc" *ngIf="fundusUnitPrice==null">Number of units for refraction </span>
      <span class="desc" *ngIf="fundusUnitPrice!=null">Refraction Price = ( Number of refraction units x <i
          class="fa fa-inr"></i>&nbsp;{{ refractionUnitPrice}} )</span>
      <input type="number" min="0" (keypress)="onlyNumberKey($event)" [(ngModel)]="packageDetails.refractionUnit"
        (keyup)="calculatePrice()" placeholder="Enter number of units for refraction here..." class="form-control">
    </div>
    <div class="col-lg-6 form-group" *ngIf="showRefractionModule==true">
      <label class="form-label">Tele-Refraction Unit(s)</label>
      <span class="desc" *ngIf="fundusUnitPrice==null">Number of units for tele-refraction </span>
      <span class="desc" *ngIf="fundusUnitPrice!=null" style="margin-left: 0px !important;">
        Tele-refraction Price = ( Number of tele-refraction units x <i class="fa fa-inr"></i>&nbsp;{{
        teleRefractionUnitPrice}} )</span>
      <input type="number" min="0" (keypress)="onlyNumberKey($event)" [(ngModel)]="packageDetails.teleRefractionUnit"
        (keyup)="calculatePrice()" placeholder="Enter number of units for tele-refraction here..." class="form-control">
    </div>
    <!-- <div class="col-lg-6 form-group" *ngIf="showReferralModule==true">
        <label class="form-label">Referral Unit(s)</label>
        <span class="desc" *ngIf="fundusUnitPrice==null">Number of units for referral </span>
        <span class="desc" *ngIf="fundusUnitPrice!=null">Referral Price = ( Number of referral units x <i
            class="fa fa-inr"></i>&nbsp;{{ referralUnitPrice}} )</span>
        <input type="number" min="0" [(ngModel)]="packageDetails.referralUnit" (keyup)="calculatePrice()"
          placeholder="Enter number of units for referral here..." class="form-control">
      </div> -->
    <div class="col-lg-6 form-group">
      <label class="form-label">Price <span class="mandatory-symbol">*</span></label>
      <span class="desc">Total price for all the modules</span>
      <input type="number" min="0" (keypress)="onlyNumberKey($event)" [(ngModel)]="packageDetails.price"
        class="form-control" placeholder="Enter price here..." required>
    </div>
    <div class="col-lg-6 form-group">
      <label class="form-label">Currency <span class="mandatory-symbol">*</span></label>
      <span class="desc">Select INR for domestic and USD for international</span>
      <select [(ngModel)]="packageDetails.currency" required class="form-select form-select-sm" #currency="ngModel"
        id="currency" name="currency">
        <option *ngFor="let currency of currencyList" [ngValue]="currency">{{currency}}
        </option>
      </select>
    </div>
  </div>

  <div class="row" style="margin-top: 20px; margin-bottom: 20px;">
    <div class="col-lg-3 form-group chiller_cb">
      <div class="col-lg-12 padding-left-0">
        <input name="isAIPackage" id="isAIPackage" [(ngModel)]="packageDetails.isAiPackageEnabled" type="checkbox"
          (change)="onAIpackageEnabled()" [disabled]="viewMode == 'edit'" />
        <label class="form-label" for="isAIPackage">Is AI Package?</label>
        <span></span>
      </div>
    </div>
    <div *ngIf="packageDetails.isAiPackageEnabled==true" class="col-lg-4 form-group">
      <label class="form-label">AI Provider(s) <span class="mandatory-symbol">*</span></label>
      <ng-multiselect-dropdown *ngIf="viewMode!=='edit'" [settings]="multiselectAIDropdownSettings"
        [data]="AIproviderList" placeholder="Select AI Provider" [(ngModel)]="selectedAIproviderIds">
      </ng-multiselect-dropdown>
      <ng-multiselect-dropdown *ngIf="viewMode=='edit'" [settings]="multiselectAIDropdownSettings"
        [data]="selectedAIproviderIds" [(ngModel)]="selectedAIproviderIds" [disabled]="true">
      </ng-multiselect-dropdown>
    </div>
    <div *ngIf="packageDetails.isAiPackageEnabled==true" class="col-lg-5 form-group">
      <label class="form-label">Category <span class="mandatory-symbol">*</span></label>
      <select [(ngModel)]="packageDetails.category" required class="form-select form-select-sm pull-right"
        id="aiCategory" name="aiCategory" [disabled]="viewMode=='edit'">
        <option value="">Select Category</option>
        <option value="RETINA">Retina</option>
        <option value="CORNEA">Cornea</option>
        <option value="DRY_EYE">Dry Eye</option>
      </select>
    </div>

  </div>
  <div class="row" style="margin-top: 20px; margin-bottom: 20px;">
    <div class="col-lg-4 form-group" *ngIf="packageDetails.isAiPackageEnabled==true">
      <label class="form-label">AI Unit(s) <span class="mandatory-symbol">*</span></label>
      <span class="desc">Number of AI units</span>
      <input type="number" min="0" (keypress)="onlyNumberKey($event)" [(ngModel)]="AIproviderUnits"
        placeholder="Enter the number of AI units here..." class="form-control">
    </div>
  </div>

  <!-- <div *ngIf="isRenewalLinkGenerated" class="row" style="margin-bottom: 20px;">
    <div class="col-lg-6">
      <label class="form-label">Package Renewal Link</label>
      <div style="display:flex">
        <input disabled type="text" [(ngModel)]="packageRenewalLink" name="renewalLink" id="renewalLink"
          class="form-control" style="cursor: text;" />

        <button type="button" [disabled]="!isRenewalLinkGenerated" title="Copy Link" class="btn btn-warning btn-raised"
          (click)="copyInviteLinkHandler()" style="margin-left:20px">
          <i class="fa fa-clone" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div> -->
  <div class="row">
    <div class="col-xs-12 text-center">
      <button *ngIf="viewMode=='new'" class="btn btn-sm btn-success marginLR5" (click)="savePackages('new')">
        <i class="fa fa-fw fa-lg fa-check-circle"></i>
        Save Package</button>

      <!-- <button *ngIf="viewMode=='edit'" class="btn btn-sm btn-success marginLR5" (click)="savePackages('edit')">
        <i class="fa fa-fw fa-lg fa-check-circle"></i>
        Update Package</button> -->

      <!-- <button *ngIf="!isRenewalLinkGenerated && viewMode=='edit'" type="button"
        class="btn btn-sm btn-info btn-raised marginLR5" (click)="generatePackageRenewalLink()"
        style="background-color:#21618C; margin-left: 20px;">
        Generate Package Renewal Link
      </button> -->
    </div>
  </div>
</div>